import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Time, BulkSubscriptionSummary, Compass } from "huddyapi";

@Component({
  selector: 'compass-summary-chart',
  templateUrl: 'compass-summary-chart.html',
  styleUrls: ["./compass-summary-chart.scss"]
})
export class CompassSummaryChart implements OnInit {

  @ViewChild('container', { static: true }) container: ElementRef;
  @Input() summary : BulkSubscriptionSummary;

  static PADDING_MARGIN: number = 60;

  data: any[];
 

  view: any[] = [700, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Recommendation';
  showYAxisLabel = true;
  yAxisLabel = 'Number of Results';

  colorScheme = {
    domain: ['#e7e7e7', '#aae3f5', '#95bfff',  '#c6c6fd', '#e3b5f5', '#f9aacf', '#d4f6dc']
  };

  constructor() {
    
  }

  ngOnInit() {
    this.data = [
      {
        name : "Incomplete",
        value: this.summary.incomplete
      }
    ];
    let i : number = 0;
    if (this.summary && this.summary.scoreSummaryRanges) {
      for (let range of this.summary.scoreSummaryRanges) {
        this.data.push({
          name : range.name,
          value : this.summary.counts[i++]
        })
      }
    }
    if (this.summary && this.summary.uninterpreted && this.summary.uninterpreted > -1) {
      this.data.push({
        name : 'Uninterpreted',
        value : this.summary.uninterpreted
      });
    }
    if (this.container) {
      this.setGraphSizes();
    }
  }

  onSelect(event) {
    console.log(event);
  }

  formatTicks(s : string) {
    return Number.parseFloat(s).toFixed();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setGraphSizes();
  }
  setGraphSizes() {
    // console.log('container', this.container.nativeElement.offsetWidth, this.container.nativeElement.offsetHeight, this.container.nativeElement.clientWidth, this.container.nativeElement.clientHeight);
    // let clientWidth : number = this.container.nativeElement.clientWidth - CompassSummaryChart.PADDING_MARGIN;//Math.max(700, this.container.nativeElement.clientWidth, 700) - CompassSummaryChart.PADDING_MARGIN;
    // let clientHeight : number = this.container.nativeElement.offsetHeight- CompassSummaryChart.PADDING_MARGIN;// Math.max(this.container.nativeElement.offsetHeight, 500) - CompassSummaryChart.PADDING_MARGIN;
 
    // this.container.nativeElement.style.width = clientWidth + 'px';
    // this.container.nativeElement.style.height = clientHeight + 'px';
    
    this.view = [640, 480];
    console.log('view size', this.view);
   
  
}
}